/** The subset of a bank a logo is read from, whichever query selected it. */
export interface IBankLogoFields {
  logoUrl?: string | null;
  logoBase64Encoding?: string | null;
}

/**
 * Where a bank's logo comes from, or `null` when it has none — the hosted URL
 * where there is one, else the embedded copy as a data URI.
 *
 * One home for a coalesce that three surfaces need: the entity avatar, the
 * assistant's entity chip, and the alert row's logo tile. They read it off
 * different generated types, so the parameter is structural rather than a
 * fragment, and an empty string normalizes to `null` so a caller can ask
 * `=== null` rather than re-deriving falsiness.
 */
export const bankLogoSrc = (bank: IBankLogoFields | null | undefined): string | null =>
  bank?.logoUrl || (bank?.logoBase64Encoding ? `data:image/png;base64,${bank.logoBase64Encoding}` : null);

export default bankLogoSrc;
